import dataServices from '@/shared/api/dataServices';
import {
  GET_CONTRACTS
} from '../mutation-types';

const state = () => ({
  contracts: []
});

const mutations = {
  [GET_CONTRACTS](state, contracts) {
    state.contracts = contracts;
  }
};
const actions = {
  async getContractAction({ commit }) {
    const contracts = await dataServices.getContracts();
    console.log(contracts);
    commit(GET_CONTRACTS, contracts);
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
